import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createCustomerAsync } from "../../redux/features/customer/customerThunks";

export const CreateAccount = ({ 
  mobileNumber, 
  onAccountCreated = () => {},
  serviceType = "delivery", // default to delivery for backward compatibility
  createCustomerThunk = null // allow passing custom thunk for catering
}) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_country_code: "+965",
    mobile_number: mobileNumber,
    email: "",
    password: "12345678", // Default password (optional)
    service_type: serviceType, // Include service type in form data
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    status: null, // 'success', 'error'
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear error messages when user starts typing again
    if (submitStatus.status === 'error') {
      setSubmitStatus({ status: null, message: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ status: null, message: '' });

    try {
      // Use custom thunk if provided (for catering), otherwise use default
      const thunkToUse = createCustomerThunk || createCustomerAsync;
      
      // Await the dispatch result to handle success/error
      const resultAction = await dispatch(thunkToUse(formData));
      
      // Check if resultAction is defined and has a success property
      if (resultAction && resultAction.success) {
        // On success, immediately call onAccountCreated without showing any success message
        onAccountCreated();
        return; // Exit early to avoid setting isSubmitting to false
      } else {
        // Error handling - extract message from the known error format
        let errorMessage = 'Failed to create account. Please try again.';
        
        // The API returns: {"status":"Error","statusCode":422,"message":"Customer already exist!!"}
        // Extract the message directly if available
        if (resultAction && resultAction.error && resultAction.error.message) {
          errorMessage = resultAction.error.message;
        }
        
        setSubmitStatus({
          status: 'error',
          message: errorMessage
        });
      }
    } catch (error) {
      console.log(error, "Error");
      setSubmitStatus({
        status: 'error',
        message: 'Failed to create account. Please try again.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="-mt-5">
      <div className="flex justify-center sm:justify-start">
        <input
          type="text"
          readOnly
          value={submitStatus.status === 'error' ? submitStatus.message : ''}
          placeholder="Account NOT Found"
          className={`border ${
            submitStatus.status === 'error' ? 'border-red-700' : 'border-red-700'
          } bg-neutral-50 rounded-xl focus:ring-1 focus:ring-red-700 focus:outline-none ${
            submitStatus.status === 'error' ? 'text-red-700' : 'placeholder-red-700'
          } placeholder-bold px-4 py-2 w-[228px] sm:w-[310px] h-12 mt-3`}
        />
      </div>

      <form onSubmit={handleSubmit}>
        <div className="flex flex-col sm:flex-row sm:space-x-2 items-center mt-3">
          <div className="mb-2 sm:mb-0">
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              placeholder="First Name"
              required
              disabled={isSubmitting}
              className="border border-slate-300 bg-neutral-50 focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold h-12 w-full sm:w-[150px] px-4 py-2 rounded-xl disabled:opacity-70"
            />
          </div>

          <div className="mb-2 sm:mb-0 px-1">
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Last Name"
              required
              disabled={isSubmitting}
              className="border border-slate-300 bg-neutral-50 focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold h-12 w-full sm:w-[150px] px-4 py-2 rounded-xl disabled:opacity-70"
            />
          </div>
        </div>

        <div className="flex justify-center sm:justify-start">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="E-mail Address (optional)"
            disabled={isSubmitting}
            className="border border-slate-300 bg-neutral-50 focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold px-4 py-2 w-[228px] sm:w-[310px] h-12 rounded-xl mt-3 disabled:opacity-70"
          />
        </div>

        <div className="flex justify-center sm:justify-start">
          <button
            type="submit"
            disabled={isSubmitting}
            className={`text-white font-bold ${
              isSubmitting
                ? 'bg-amber-500 cursor-not-allowed'
                : 'bg-amber-800 hover:bg-amber-900'
            } rounded-xl focus:ring-1 focus:ring-amber-800 focus:outline-none w-[228px] sm:w-[310px] h-12 mt-3 disabled:opacity-80`}
          >
            {isSubmitting ? 'Creating Account...' : 'Create New Account'}
          </button>
        </div>
      </form>
    </div>
  );
};
